import { ConfigProvider, Table } from "antd"
import { createCartColumns } from "@/components/view-cart/cartTableColumns"
import styles from "@/styles/view-cart.module.scss"

interface CartTableProps {
  dataSource: any[]
  loadingRows: Record<string | number, boolean>
  rowSelection: any
  onAddonInfoClick?: () => void
  onDeleteItem: (_record: any) => void
  onExpressChange: (_record: any, _event: any) => void
  onQtyChange: (_record: any, _value: string | number) => void
  onWishlistItem: (_record: any) => void
}

const CartTable = ({
  dataSource,
  loadingRows,
  rowSelection,
  onAddonInfoClick,
  onDeleteItem,
  onExpressChange,
  onQtyChange,
  onWishlistItem
}: CartTableProps) => (
  <div className={styles['table-box']}>
    <ConfigProvider
      theme={{
        components: {
          Table: {
            controlItemBgActiveHover: "#fafafa",
            controlItemBgActive: "#fff",
          }
        }
      }}
    >
      <Table
        dataSource={dataSource}
        rowKey="productID"
        columns={createCartColumns({
          disabled: false,
          loadingRows,
          onAddonInfoClick,
          onDeleteItem,
          onExpressChange,
          onQtyChange,
          onWishlistItem
        })}
        rowSelection={rowSelection}
        rowClassName={(record: any) => record.isAddonRow ? `${styles['addon-table-row']} ${record.addonStatus === 'locked' ? styles['addon-locked-table-row'] : ''} ${record.isAddonLastRow ? styles['addon-last-table-row'] : ''}` : record.isAddonTitle ? styles['addon-title-table-row'] : record.isAddonColHead ? styles['addon-head-table-row'] : record.isAddonDivider ? styles['addon-divider-table-row'] : ''}
        pagination={false}
      />
    </ConfigProvider>
  </div>
)

export default CartTable
